// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0ab1c70b","453":"8ab44547","621":"99929f5f","656":"3f40550f"}[chunkId] + ".chunk.js";
};